<template>
    <div class="row justify-content-center my-4 budget-table">
        <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>
        <div v-if="showQueries" v-html="this.query" style="word-wrap:anywhere;">{{ this.query }}</div>
        <div class="col">
            <div class="row row-cols-md-2 mb-2">
                <div class="col-md-3 col-xl-2 months">
                    <v-select v-model="selected_view" :reduce="view => view.id" label="view" :options="views"></v-select>
                </div>
                <div class="col-md-3 col-xl-2 months">
                    <v-select v-model="selected_month" :reduce="month => month.key" label="month" :options="months"></v-select>
                </div>
                <div v-show="selected_view==0" class="col-md-4 col-xl-3 managers">
                    <v-select v-model="selected_project_manager" :reduce="project_manager => project_manager.id" label="full_name" :options="project_managers"></v-select>
                </div>
                <div v-show="selected_view==1" class="col-md-4 col-xl-2 details">
                    <v-select v-model="selected_card_detail" :reduce="detail => detail.id" label="detail" :options="card_details"></v-select>
                </div>
                <div class="col-md-2 col-xl-5 text-right">
                    <router-link :to="{ path: '/budget/issues' }" class="btn btn-secondary main-button pull-right ml-3">Issues</router-link>
                    <router-link :to="{ path: '/budget/alerts' }" class="btn btn-secondary main-button pull-right">Alerts</router-link>
                </div>
            </div>
            <div class="row">
                <div  class="col d-flex flex-column justify-content-center mt-2">
                    <div class="table-wrap flex-grow-1 p-3" :class="'view_'+selected_view+'_'+selected_card_detail">
                        <template v-if="selected_view == 0  && !reloading">
                            <v-client-table :data="tableData" :columns="columns" :options="options">
                                <template v-for="(column, idx) in columns" :slot="column" slot-scope="props">
                                    <template v-if="column=='name'"><span class="client-name" :title="props.row[column]">{{props.row[column]}}</span></template>
                                    <template v-else-if="props.row[column] && props.row[column]['spend']">
                                        <span class="arrow-wrap" @mouseover="showTooltip" @mouseleave="hideTooltip">{{props.row[column]['spend']}}<span v-if="!!props.row[column]['budget_raw']" class="arrow" :class="[props.row[column]['sign'], props.row[column]['color']]"></span></span>
                                        <template v-if="use_multiply">
                                            <span class="custom-tooltip hidden" :class="column">Budget:{{props.row[column]['budget']}}<br>Spend to Date:{{props.row[column]['spend']}}<br>Projected Spend:{{props.row[column]['projected_spent']}}</span>
                                        </template>
                                        <template v-else>
                                            <span class="custom-tooltip hidden short" :class="column">Budget:{{props.row[column]['budget']}}<br>Spend:{{props.row[column]['spend']}}</span>
                                        </template>
                                    </template>
                                </template>
                            </v-client-table>
                        </template>
                        <template v-if="selected_view == 1 && (selected_card_detail == 0 || selected_card_detail == 2) && !reloading">
                            <v-client-table :data="tableData" :columns="columns1" :options="options1">
                                <template v-for="(column, idx) in columns1" :slot="column" slot-scope="props">
                                    <template v-if="column=='name'"><span class="client-name" :title="props.row[column]">{{props.row[column]}}</span></template>
                                    <template v-else-if="props.row[column] && props.row[column]['spend']">
                                        <span class="arrow-wrap narrow" @mouseover="showTooltip" @mouseleave="hideTooltip">{{props.row[column]['spend']}}<span v-if="!!props.row[column]['budget_raw']" class="arrow" :class="[props.row[column]['sign'], props.row[column]['color']]"></span></span>
                                        <template v-if="use_multiply">
                                            <span class="custom-tooltip hidden" :class="column">Budget:{{props.row[column]['budget']}}<br>Spend to Date:{{props.row[column]['spend']}}<br>Projected Spend:{{props.row[column]['projected_spent']}}</span>
                                        </template>
                                        <template v-else>
                                            <span class="custom-tooltip hidden short" :class="column">Budget:{{props.row[column]['budget']}}<br>Spend:{{props.row[column]['spend']}}</span>
                                        </template>
                                    </template>
                                </template>
                            </v-client-table>
                        </template>
                        <template v-if="selected_view == 1 && selected_card_detail == 1 && !reloading">
                            <v-client-table :data="tableData" :columns="columns2" :options="options2">
                                <template v-for="(column, idx) in columns2" :slot="column" slot-scope="props">
                                    <template v-if="column=='name'"><span class="client-name" :title="props.row[column]">{{props.row[column]}}</span></template>
                                    <template v-else-if="!!props.row[column]">
                                        <span class="arrow-wrap" @mouseover="showTooltip" @mouseleave="hideTooltip">{{props.row[column]['spend']}}<span v-if="!!props.row[column]['budget_raw']" class="arrow" :class="[props.row[column]['sign'], props.row[column]['color']]"></span></span>
                                        <template v-if="use_multiply">
                                            <span class="custom-tooltip hidden" :class="column">Budget:{{props.row[column]['budget']}}<br>Spend to Date:{{props.row[column]['spend']}}<br>Projected Spend:{{props.row[column]['projected_spent']}}</span>
                                        </template>
                                        <template v-else>
                                            <span class="custom-tooltip hidden short" :class="column">Budget:{{props.row[column]['budget']}}<br>Spend:{{props.row[column]['spend']}}</span>
                                        </template>
                                    </template>
                                </template>
                            </v-client-table>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },
        data() {
            return {
                initialized1:false,
                initialized2:false,
                selected_project_manager: null,
                project_managers:[],
                selected_month:null,
                months:[],
                views:[{'id':0, 'view':'Clients'}, {'id':1, 'view':'Cards'}],
                selected_view:0,
                card_details:[{'id':0, 'detail':'Credit Card'}, {'id':1, 'detail':'Client'}, {'id':2, 'detail':'Global'}],
                selected_card_detail:0,
                use_multiply:null,
                columns: ['name', 'adwords', 'intent_audiences', 'customer_match', 'display', 'in_market', 're_marketing', 'similar_audiences', 'social'],
                columns1: ['name', 'spend'],
                columns2: [],
                tableData: [],
                options: {
                    headings: {
                        name:    'Client Name',
                        adwords: 'ADWORDS',
                        //affinity_audiences:'AFFINITY AUDIENCE',
                        intent_audiences:'CUSTOM INTENT',
                        custom_audience:'CUSTOM AUDIENCE',
                        customer_match:'CUSTOMER MATCH',
                        display:'DISPLAY',
                        in_market:'IN-MARKET',
                        re_marketing:'RE-MARKETING',
                        similar_audiences:'SIMILAR AUDIENCE',
                        social: 'PAID SOCIAL'
                    },
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    perPage: 999,
                    perPageValues: [],
                    skin: 'table'
                },
                options1: {
                    headings: {
                        name:  'Card',
                        spend: 'Spend'
                    },
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    perPage: 999,
                    perPageValues: [],
                    skin: 'table'
                },
                options2: {
                    headings: null,
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    perPage: 999,
                    perPageValues: [],
                    skin: 'table'
                },
                reloading:true,
                query:'',
                showQueries:    this.$route.path == '/budget/query'
            }
        },
        methods: {
            fetchServerData() {
                this.reloading = true;

                const params = JSON.stringify({
                    'manager_id':this.selected_project_manager || 0,
                    'month': this.selected_month || 0,
                    'view_id': this.selected_view || 0,
                    'detail_id' : this.selected_card_detail || 0
                });
                axios.all([
                    axios.get(`/api/project_managers`),
                    axios.get('/api/months'),
                    axios.get(`/api/budget?params=${params}`)
                ]).then(axios.spread((project_managers, months, budgets) => {
                    this.project_managers = project_managers.data;
                    this.months = months.data;
                    if(!this.selected_project_manager){
                        this.selected_project_manager = 0;
                    }
                    if(!this.selected_month){
                        this.selected_month = 0;
                    }
                    if(this.selected_view == 1 && this.selected_card_detail == 1){
                        this.columns2 = budgets.data.columns;
                        this.options2.headings = budgets.data.headings;
                    }
                    this.tableData = budgets.data.results;
                    this.use_multiply = budgets.data.use_multiply;
                    this.overflowVisible();
                    this.query = budgets.data.query;
                    this.reloading = false;
                }));
            },
            overflowVisible(){
                setTimeout(() => {
                    const table_responsive = $('.table-responsive');
                    const VueTables__table = table_responsive.find('.VueTables__table');
                    const ancestor = $('div.table-wrap');

                    if(ancestor.hasClass('view_1_0') || ancestor.hasClass('view_1_2')){
                        VueTables__table.addClass('narrow');
                        const tr = VueTables__table.find('tr');
                        const td = tr.find('td');

                        $(td[0]).addClass('narrow');
                    }
                    table_responsive.removeAttr("style").css('overflow', 'visible');
                    VueTables__table.removeAttr("style").css('overflow-y', 'visible');
                }, 500);
            },
            showTooltip(event){
                $(event.target).closest('td').find('span.custom-tooltip').removeClass('hidden');
            },
            hideTooltip(){
                $(event.target).closest('td').find('span.custom-tooltip').addClass('hidden');
            }
        },
        watch: {
            selected_project_manager(value){
                if(this.initialized1 && this.initialized2){
                    this.fetchServerData();
                }
                this.initialized1 = true;
            },
            selected_month(value){
                if(this.initialized1 && this.initialized2){
                    this.fetchServerData();
                }
                this.initialized2 = true;
            },
            selected_view(value){
                this.fetchServerData();
            },
            selected_card_detail(value){
                this.fetchServerData();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/_variables.scss';
    div.budget-table{
        span.custom-tooltip{
            display:inline-block;
            position:absolute;
            left:1.5rem;
            bottom:-7.8rem;
            padding:0.8rem;
            color:white;
            background-color:black;
            line-height:2rem;
            white-space: nowrap;
            border-radius:0.5rem;
            z-index:999;
            &.short{
                bottom:-6rem;
            }
            &::before {
                border-left: 0.5vw solid transparent;
                border-right: 0.5vw solid transparent;
                content: "";
                display: inline-block;
                height: 0;
                width: 0;
                margin-right:0.4rem;
                border-bottom: 0.8rem dashed #000;
                position: absolute;
                top: -0.8rem;
                left: 10%;
            }
            &.social{
                left:-1.5rem;
                &::before{
                    left:20%;
                }
            }
        }
        div.table-wrap {
            border-radius:2rem;
            border:0.2rem solid $black-blue;
        }
        div.managers{
            div.v-select{
                @media screen and (min-width: 1280px) {
                    max-width:24rem;
                }
            }
        }
        table td{
            line-height:2rem;
            position:relative;
        }
        span.client-name{
            font-size:1vw;
            white-space:nowrap;
        }
        span.arrow-wrap{
            font-size:1vw;
            position:relative;
            display:inline-block;
            width:100%;
            &.narrow{
                max-width:15rem !important;
            }
            span.arrow {
                position: absolute;
                right: -1rem;
                bottom: 0.2vw;
                font-size:0.75vw;
                &::before {
                    border-left: 0.5vw solid transparent;
                    border-right: 0.5vw solid transparent;
                    content: "";
                    display: inline-block;
                    height: 0;
                    width: 0;
                    margin-right:0.4rem;
                }
                &.up{
                    &.red{
                        &::before {
                            border-bottom: 0.8rem dashed #D03C00;
                        }
                    }
                    &.amber{
                        &::before {
                            border-bottom: 0.8rem dashed #fdcd5e;
                        }
                    }
                    &.green{
                        &::before {
                            border-bottom: 0.8rem dashed #50caa1;
                        }
                    }
                }
                &.down{
                    &.red{
                        &::before {
                            border-top: 0.8rem dashed #D03C00;
                        }
                    }
                    &.amber{
                        &::before {
                            border-top: 0.8rem dashed #fdcd5e;
                        }
                    }
                    &.green{
                        &::before {
                            border-top: 0.8rem dashed #50caa1;
                        }
                    }
                }
            }
            & > span.tooltip{
                display:inline-block;
                position:absolute;
                right:0;
                top:0;
            }
        }
    }
    div.table-responsive{
        min-height:13rem;
        table{
            min-height:13rem;
            overflow-y:visible;
        }
    }

</style>
<style>
    td.narrow{
        width:15% !important;
    }
    td:first-child {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    th{
        text-align:left !important;
    }
</style>
